import React, { useState } from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { postUserUpdate } from "../../services/callApi";
import { API_QUERY_KEYS, invalidateApiQueries } from "../../utils/apiQueryCache";
import { ManagementIconActionButton } from "../common/ManagementListLayout";

function UserDeleteDialog({ user, onDeleted }) {
  const [open, setOpen] = React.useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = async () => {
    if (isButtonDisabled) {
      return;
    }

    try {
      const requestBody = {
        user_id: user.userId,
        name: user.name,
        furigana: user.furigana,
        address: user.address,
        phone_number: user.phoneNumber,
        email_address: user.emailAddress,
        is_active: false,
      };

      setIsButtonDisabled(true);

      console.log(JSON.stringify(requestBody));
      await postUserUpdate(requestBody);
      invalidateApiQueries(API_QUERY_KEYS.userList, API_QUERY_KEYS.userDetail(user.userId));
      handleClose();
      await onDeleted?.();
    } catch (error) {
      console.error("エラーが発生しました", error);
      alert("ユーザーの削除中にエラーが発生しました");
    } finally {
      setIsButtonDisabled(false);
    }
  };

  return (
    <React.Fragment>
      <ManagementIconActionButton
        ariaLabel={`${user.name}を削除`}
        tooltip="削除"
        onClick={handleClickOpen}
      >
        <FontAwesomeIcon icon={faTrash} />
      </ManagementIconActionButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          ユーザー削除
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ユーザー : {user.name}を削除します。
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={isButtonDisabled} onClick={handleDelete}>はい</Button>
          <Button onClick={handleClose} autoFocus>いいえ</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default UserDeleteDialog;
